"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstanceMethods = exports.isGetter = void 0;
var EventLogger_1 = require("./EventLogger");
var isGetter = function (obj, prop) {
    var _a;
    return !!((_a = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(obj), prop)) === null || _a === void 0 ? void 0 : _a.get);
};
exports.isGetter = isGetter;
var getInstanceMethods = function (obj) {
    var keys = [];
    var topObject = obj;
    var onlyOriginalMethods = function (item, i, arr) { return !exports.isGetter(topObject, item)
        && typeof topObject[item] === 'function'
        && item !== 'constructor'
        && (i === 0 || item !== arr[i - 1])
        && keys.indexOf(item) === -1; };
    do {
        var l = Object.getOwnPropertyNames(obj)
            .sort()
            .filter(onlyOriginalMethods);
        keys = keys.concat(l);
        obj = Object.getPrototypeOf(obj);
    } while (obj && Object.getPrototypeOf(obj));
    return keys;
};
exports.getInstanceMethods = getInstanceMethods;
var EventLoggerMock = new EventLogger_1.default({ initialize: false });
var instanceMethods = exports.getInstanceMethods(EventLoggerMock);
instanceMethods.forEach(function (method) {
    EventLoggerMock[method] = function () { };
});
exports.default = EventLoggerMock;
